<div class="mt-4">
  <form [formGroup]="dateRangeData" id="date-range-selector-form">
    <label for="dateRangeInput" class="form-label h-4 mb-3">View Date Range</label>
    <div class="position-relative">
      <div class="position-relative">
        <input id="dateRangeInput" type="text" readonly class="form-control pe-5" [value]="getDateRangeDisplay()"
          placeholder="Select date" (click)="toggleDatePicker()" style="cursor: pointer" />

        <i class="bi bi-calendar-check position-absolute top-50 end-0 translate-middle-y me-3"
          (click)="toggleDatePicker()" (keydown.enter)="toggleDatePicker()" (keydown.space)="toggleDatePicker()"
          tabindex="0" role="button" aria-label="Toggle date picker" style="cursor: pointer"></i>
      </div>
      @if (showDatePicker) {
      <div
        class="datepicker-dropdown position-absolute top-100 start-0 mt-1 bg-white border rounded shadow-lg fw-normal fs-6 z-1000"
        (click)="$event.stopPropagation()" tabindex="0" (keydown.escape)="closeDatePicker()">
        <groundworks-date-picker [isRangeSelection]="true" [displayMonths]="1" (fromDateEvent)="handleFromDate($event)"
          (toDateEvent)="handleToDate($event)" [minDate]="minDate" />
      </div>
      }
    </div>
  </form>
</div>
